// extracted by mini-css-extract-plugin
export default {"modalContainer":"z1-z","modalIndicator":"A1-z","prevBtn":"B1-z","nextBtn":"C1-z","body":"D1-z","footer":"E1-z"};